import styled, {css} from 'styled-components';

import MoreSVG from '../../../../assets/icons/more.svg';
import CalendarSVG from '../../../../assets/icons/secondary/Calendar.svg';
import {getColor, ms, square} from '../../../../styles';
import {Button} from '../../../../uikit/Button';
import {Clickable} from '../../../../uikit/Clickable';
import {Image} from '../../../../uikit/Image';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)<{selected?: boolean}>`
  padding-block: ${ms(12)};
  padding-inline: ${ms(16)};
  align-items: center;
  column-gap: ${ms(12)};
  background-color: ${getColor('background1')};
  border-radius: ${ms(12)};

  ${p =>
    platform.isNative &&
    css`
      flex-direction: row;
      margin-inline: ${ms(20)};
      margin-block-start: ${ms(8)};
      border-width: 1px;
      border-style: solid;
      border-color: ${getColor(p.selected ? 'border3' : 'border1')};
    `};
`;

export const Avatar = styled(Image)`
  ${square(40)};
  border-radius: ${ms(20)};
`;

export const InfoContainer = styled(View)`
  flex-direction: column;

  ${platform.isWeb &&
  css`
    width: ${ms(176)};
  `};

  ${platform.isNative &&
  css`
    flex: 1;
  `};
`;

export const CourseLabelRow = styled(View)`
  flex-direction: row;
  flex: 1;
  align-items: center;
  column-gap: ${ms(8)};
`;

export const MainTruncatedText = styled(Text).attrs({
  nativeProps: {numberOfLines: 1},
  weight: 'semibold',
})`
  ${() =>
    platform.isWeb &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `};

  ${platform.isNative &&
  css`
    flex: 1;
  `};
`;

export const CreatedAt = styled(Text).attrs({color: 'text3'})`
  font-size: ${ms(12)};
`;

export const CalendarIcon = styled(CalendarSVG).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(platform.isWeb ? 20 : 16)};
`;

export const RightContainer = styled(View)`
  flex-direction: row;
  margin-inline-start: auto;
  column-gap: ${ms(12)};
`;

export const ActionButton = styled(Button)`
  padding-inline: ${ms(24)};
`;

export const MoreButton = styled(Clickable)`
  display: flex;
  align-items: center;
`;

export const MoreIcon = styled(MoreSVG).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(24)};
`;
